import { Component } from '@angular/core';
import { forkJoin } from 'rxjs';
import { CampaignSettingsAbstractComponent } from '../campaign-settings-abstract.component';
import { Campaign, CampaignSection, CRM, CRMCampaign, CRMTypeId, Pager, CRMStatus } from '../../_models';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
  AlertService,
  CampaignService,
  CRMCampaignService,
  CRMService,
  LoaderService,
  SideNavService,
} from '../../_services';
import { FormBuilder } from '@angular/forms';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { config } from '../../../config/config';

@Component({
  templateUrl: './campaign-crms.component.html',
  styleUrls: ['../campaign-section.scss', './campaign-crms.component.scss'],
})
export class CampaignCRMsComponent extends CampaignSettingsAbstractComponent {
  public section = CampaignSection.CRMCampaigns;
  selectedCRMCampaigns: {} = {};
  CRMCampaigns: {} = {};
  selectedCRMId = null;
  crms: CRM[];
  crmsLoading = false;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected campaignService: CampaignService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected sideNav: SideNavService,
    protected modalService: NgxSmartModalService,
    protected loaderService: LoaderService,
    protected crmService: CRMService,
    protected crmCampaignService: CRMCampaignService
  ) {
    super(router, location, route, campaignService, sideNav, alertService, loaderService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      crm_campaigns: [[]],
    });

    super.ngOnInit();
  }

  onCampaignFetch(data: Campaign) {
    this.crmsLoading = true;
    forkJoin([
      this.crmService.list({
        page: 1,
        page_size: config.maxPageSize,
        'type!': CRMTypeId.Test,
        'status!': CRMStatus.Deleted,
      }),
      this.crmCampaignService.list({
        page: 1,
        page_size: config.maxPageSize,
        'crm__type!': CRMTypeId.Test,
        'crm__status!': CRMStatus.Deleted,
      }),
    ]).subscribe(
      (data: [Pager, Pager]) => {
        this.crmsLoading = false;
        let selectedCRMCampaigns = {};

        this.crms = data[0].results;

        //initialize empty crm campaign arrays for each crm
        this.crms.forEach((crm: CRM) => {
          this.selectedCRMCampaigns[crm.id] = [];
          this.CRMCampaigns[crm.id] = [];
        });

        if (this.crms.length == 1) {
          this.selectedCRMId = this.crms[0].id;
        }

        //build a map of the selected crm campaign ids for faster lookup
        for (let campaign_id of this.campaign.crm_campaigns) {
          selectedCRMCampaigns[campaign_id] = true;
        }

        //fill in the list of crm campaigns for each crm
        data[1].results.forEach((campaign: CRMCampaign) => {
          if (campaign.id in selectedCRMCampaigns) {
            this.selectedCRMCampaigns[campaign.crm].push(campaign);
          }

          this.CRMCampaigns[campaign.crm].push(campaign);
        });
      },
      (error) => {
        this.crmsLoading = false;
        this.handleError(error);
      }
    );

    this.form.patchValue(data);
  }

  protected getFormData() {
    let campaignIds = [];

    this.crms.forEach((crm: CRM) => {
      this.selectedCRMCampaigns[crm.id].forEach((campaign: CRMCampaign) => {
        campaignIds.push(campaign.id);
      });
    });

    return Object.assign({}, this.form.value, { crm_campaigns: campaignIds });
  }

  displayFormat(row) {
    return `${row.name} (${row.crm_campaign_id})`;
  }
}
